export function formatJobRoleLabel(jobType: number | string | null | undefined): string {
  if (jobType === null || jobType === undefined || jobType === "") return "Dental Professional";
  switch (Number(jobType)) {
    case 0:
      return "Dental Hygienist";
    case 1:
      return "Dental Assistant";
    case 2:
      return "Admin/Reception";
    default:
      return "Dental Professional";
  }
}
